<div class="innerpage-fullwithbanner">
  <h2 class="bighead">{{userDetailsOutput.FirstName}} {{userDetailsOutput.LastName}}</h2>
    <ul class="bread-crumbs">
        <li><a (click)="_validationService.redirect('/')">Home<span>|</span></a></li>
        <li><a (click)="onBreadCrumbClick();">{{prevPage}}<span>|</span></a></li>
        <li>User Detail</li>
    </ul>
</div>
<div class="section-margin">
    <div class="container container-lg min-heightcontainer">
      <div class="border-div margin0">

        <div class="tabstyle2 offerdetailstab-padding pos-relative" *ngIf="userDetailsOutput.UserRoleId !== 7">
          <ul class="switchingproperty margin-bottom-15 offerlistingtab">
            <li [class.active]="activeTab === tab.PersonalInformation">
              <a (click)="onTabClick(tab.PersonalInformation)">
                Profile
              </a>
            </li>
            <li [class.active]="activeTab === tab.Associations" *ngIf="permissionService.hasPermission(Modules.Employees,Actions.AssociationsList)">
              <a (click)="onTabClick(tab.Associations)">
                Associations
              </a>
            </li>

            <li [class.active]="activeTab === tab.ActivityLog" *ngIf="permissionService.hasPermission(Modules.ActivityLog,Actions.Listings)">
              <a (click)="onTabClick(tab.ActivityLog)">
                Activity Log
              </a>
            </li>

          </ul>
        </div>
        <div [hidden]="activeTab !== tab.PersonalInformation">
          <div class="floatinghead floatinghead-xs clearfix">
            <h2 class="mainhead" *ngIf="userDetailsOutput.UserRoleId === 7"><span class="text">Personal Information</span></h2>
            <button class="right-btn btn  btn-circle btn-green adduserbtn" *ngIf="permissionService.hasPermission(Modules.Employees,Actions.Edit)" (click)="editUser();" href="#" placement="left" tooltip="Edit Employee Info" ng-reflect-tooltip="Edit" ng-reflect-placement="top"><i aria-hidden="true" class="icofont icofont-ui-edit icon"></i></button>
          </div>
          <div class="leftsideprofile">
            <div class="profilepic">
              <img src="{{userDetailsOutput.ProfilePicPath}}">
            </div>
          </div>
          <div class="rightsideprofile">
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">First name</label>
                  <h6 class="displayvalue">{{userDetailsOutput.FirstName}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Last Name</label>
                  <h6 class="displayvalue">{{userDetailsOutput.LastName}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Email</label>
                  <h6 class="displayvalue truncate-email">{{userDetailsOutput.Email ? userDetailsOutput.Email :'-'}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Phone</label>
                  <h6 class="displayvalue">{{userDetailsOutput.Phoneno | phone}}</h6>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Address Line 1</label>
                  <h6 class="displayvalue">{{userDetailsOutput.Address1!=null && userDetailsOutput.Address1!=""?userDetailsOutput.Address1:"-"}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Address Line 2</label>
                  <h6 class="displayvalue">{{userDetailsOutput.Address2!=null && userDetailsOutput.Address2!=""?userDetailsOutput.Address2:"-"}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">State</label>
                  <h6 class="displayvalue">{{userDetailsOutput.State!=null && userDetailsOutput.State!=""?userDetailsOutput.State:"-"}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">City</label>
                  <h6 class="displayvalue">{{userDetailsOutput.CityName!=null && userDetailsOutput.CityName!=""?userDetailsOutput.CityName:"-"}}</h6>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">ZIP</label>
                  <h6 class="displayvalue">{{userDetailsOutput.Zip!=null && userDetailsOutput.Zip!=""?userDetailsOutput.Zip:"-"}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Role</label>
                  <h6 class="displayvalue" *ngIf="userDetailsOutput.Is1031User==true">{{userDetailsOutput.UserRole!='Registration Pending'?'Principal + 1031':'-'}}</h6>
                  <h6 class="displayvalue" *ngIf="!userDetailsOutput.Is1031User">{{userDetailsOutput.UserRole!='Registration Pending'?userDetailsOutput.UserRole:'-'}}</h6>
                </div>
              </div>
              <!--<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
                <label class="form-label">Location</label>
                <h6 class="displayvalue"><span class="tags">IL</span><span class="tags">Texas</span><span class="tags">Florida</span></h6>
            </div>
        </div>-->
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">User Status</label>
                  <h6 class="displayvalue" [ngClass]="_validationService.applyClass(userDetailsOutput.UserStatus)">{{userDetailsOutput.UserStatus}}</h6>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label class="form-label">Company Name</label>
                  <h6 class="displayvalue">{{userDetailsOutput.CompanyName?userDetailsOutput.CompanyName:'-'}}</h6>
                </div>
              </div>
              <div class="col-lg-6 col-md-3 col-sm-6 col-xs-12">
                <div class="form-group" *ngIf="userDetailsOutput.UserRoleId === userRole.Broker || userDetailsOutput.UserRoleId === userRole.Admin|| userDetailsOutput.UserRoleId === userRole.SuperAdmin">
                  <label class="form-label">LinkedIn</label>
                  <h6 class="displayvalue">{{userDetailsOutput.UserLinkedInProfile?userDetailsOutput.UserLinkedInProfile:'-'}}</h6>
                </div>
              </div>

              <!--<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
                <label class="form-label">ZIP</label>
                <h6 class="displayvalue">61257</h6>
            </div>
        </div>-->
            </div>
          </div>
          <div class="clearfix"></div>

          <div class="margin-top-30" *ngIf="userDetailsOutput.UserRoleId != userRole.DataEntryStaff && permissionService.hasPermission(Modules.Employees,Actions.Details)">
            <div class="floatinghead clearfix">
              <h2 class="mainhead "><span class="text">{{userDetailsOutput.UserRoleId === userRole.ComplianceBroker ? 'Licenses Details' : 'Broker Regional Licenses'}}</span></h2>
            </div>
            <div class="table-responsive">
              <table class="table basictable">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>State</th>
                    <th>License No.</th>
                    <th>Expiration Date</th>
                    <th>Default</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let field of brokerRegionalLicenses;let i = index">
                    <td><p>{{i+1}}</p></td>
                    <td>
                      <p>{{field.StateName}}</p>
                    </td>
                    <td>
                      <p>{{field.BrokerLicense}}</p>
                    </td>
                    <td>
                      <p>{{field.ExpiryDate_Date| date:'MM/dd/yyyy' }} <span *ngIf="this.isExpiryDateValidate[i]==1">- Expired</span></p>
                    </td>
                    <td>
                      <i *ngIf="field.IsDefault == true" class="icon-tick icon" aria-hidden="true"></i>
                      <!--<p>{{field.IsDefault == true ? 'Default' : '' }}</p>-->
                    </td>
                  </tr>

                </tbody>


                <tfoot>


                  <tr *ngIf="brokerRegionalLicenses?.length == 0 ">
                    <td colspan="9" class="odd no-data-available">
                      <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="margin-top-30" *ngIf="userDetailsOutput.UserRoleId === userRole.DataEntryStaff && permissionService.hasPermission(Modules.Employees,Actions.Details)">
            <div class="floatinghead floatinghead-xs clearfix">
              <h2 class="mainhead "><span class="text">Designated Brokerage</span></h2>

            </div>


            <div class="table-responsive">
              <table class="table basictable">
                <thead>
                  <tr>

                    <th>Brokerage Name</th>
                    <th>Brokerage URL</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let field of result;let i = index">
                    <td>
                      <p>{{field.BrokerageName}}</p>
                    </td>
                    <td>
                      <p><a href="{{_validationService.formatURL(field.WebsiteURL)}}" target="_blank">{{field.WebsiteURL}}</a></p>
                    </td>
                  </tr>

                </tbody>
                <tfoot>
                  <tr *ngIf="result?.length == 0 ">
                    <td colspan="9" class="odd no-data-available">
                      <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

        </div>

        <div class="clearfix" *ngIf="activeTab === tab.ActivityLog && permissionService.hasPermission(Modules.ActivityLog,Actions.Listings)">
          <div class="col-md-12">
            <app-audit-trail [propertyView]="true" [User]="User" [IsDisplayUser]="1" [previousRoute]="prevPage"></app-audit-trail>
          </div>
        </div>
        <div class="clearfix" *ngIf="activeTab === tab.Associations">
          <div class="col-md-12">
            <user-associations [principalDetails]="userDetailsOutput" [moduleId]="Modules.Employees" [CurrentUser]="User" ></user-associations>
          </div>
        </div>

        <!--<div class="text-right">
      <button class="btn btn-lg btn-green" (click)="viewAuditTrail();">{{viewOrHideLabel}} Activity Log</button>
  </div>-->
        <!--<div *ngIf="isViewAuditTrail">
      <app-audit-trail [objectId]="auditObjectId" [objectTypeId]="auditObjectTypeId"></app-audit-trail>
  </div>-->

      </div>


    </div>
</div>
